import { defineStyleConfig as e } from "@chakra-ui/react";
const t = e({
  baseStyle: {
    textStyle: "bodyBold",
    color: "teal.500",
    textDecorationLine: "underline",
    textDecorationColor: "teal.500",
    _hover: {
      color: "teal.600",
      textDecorationColor: "teal.600"
    },
    _active: {
      color: "teal.700",
      textDecorationColor: "teal.700"
    },
    _focusVisible: {
      outline: "none",
      boxShadow: "outline"
    }
  },
  sizes: {
    sm: {
      textStyle: "bodyBoldSmall"
    },
    md: {
      textStyle: "bodyBold"
    }
  },
  defaultProps: {
    size: "md"
  }
});
export {
  t as default
};
